import { render, staticRenderFns } from "./testate.vue?vue&type=template&id=72b89642"
import script from "./testate.vue?vue&type=script&lang=js"
export * from "./testate.vue?vue&type=script&lang=js"
import style0 from "./testate.vue?vue&type=style&index=0&id=72b89642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports